<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9836 6.43782L21.1099 3.18002C21.0723 3.03771 20.9606 2.92716 20.8195 2.88952L17.5612 2.0145C17.3425 1.95452 17.1167 2.08624 17.0567 2.305C16.9979 2.52493 17.1285 2.75074 17.3472 2.80955L19.9176 3.49992L10.4225 12.9969C10.2614 13.1581 10.2614 13.418 10.4225 13.5791C10.5025 13.6591 10.6083 13.7003 10.7141 13.7003C10.82 13.7003 10.9246 13.6591 11.0046 13.5791L20.4997 4.08209L21.1899 6.65187C21.2393 6.83534 21.4063 6.95648 21.5873 6.95648C21.6226 6.95648 21.6591 6.95178 21.6943 6.94237C21.9131 6.88356 22.0424 6.65775 21.9836 6.43782Z"
      :fill="iconColor"
    />
    <path
      d="M19.0781 9.31926C18.8511 9.31926 18.6665 9.50391 18.6665 9.7309L18.6665 21.1767L2.8241 21.1767L2.8241 5.3311L14.1418 5.3311C14.3687 5.3311 14.5533 5.14645 14.5533 4.91946C14.5533 4.69248 14.3699 4.50783 14.1418 4.50783L2.41255 4.50783C2.18443 4.50783 1.99982 4.69248 1.99982 4.91947L1.99982 21.5884C1.99982 21.8154 2.18443 22 2.41137 22L19.0781 22C19.305 22 19.4896 21.8165 19.4896 21.5884L19.4896 9.7309C19.4896 9.50391 19.3062 9.31926 19.0781 9.31926Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconExport",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
